export enum DataGroupType {
    NONE = 'none',
    DATASOURCE = 'datasource',
    GENERATOR = 'generator',
    METRIC = 'metric',
}
